/**
 * AdminModuleLandingsPage — thin wrapper around the unified LandingPagesSettings
 * component, providing a dedicated route at /admin/module-landing-pages.
 *
 * This was previously a separate editor (ModuleLandingEditor.jsx). Both paths
 * (/admin/module-landing-pages AND /admin/system-settings → Landing Pages tab)
 * now render the SAME component to keep the source of truth unified.
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { DashboardLayout } from '@/components/layouts';
import { Button } from '@/components/ui/button';
import { ArrowLeft, Settings } from 'lucide-react';
import LandingPagesSettings from '@/components/LandingPagesSettings';

const AdminModuleLandingsPage = () => {
  const navigate = useNavigate();
  return (
    <DashboardLayout title="Module Landing Pages">
      <div className="space-y-4" data-testid="admin-module-landings-page">
        <div className="flex items-center justify-between gap-3 flex-wrap">
          <Button variant="ghost" size="sm" onClick={() => navigate('/admin')}>
            <ArrowLeft className="h-4 w-4 mr-1" /> Back
          </Button>
          <Button
            variant="outline"
            size="sm"
            onClick={() => navigate('/admin/settings?tab=landing')}
            data-testid="open-in-system-settings-btn"
          >
            <Settings className="h-4 w-4 mr-1" /> Open in System Settings
          </Button>
        </div>
        <LandingPagesSettings />
      </div>
    </DashboardLayout>
  );
};

export default AdminModuleLandingsPage;
